.FormFieldWrapper {
}

.withLabelOnLeft {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.FormLabel {
  font-weight: 400;
}

.labelWithAddon {
  display: inline-block;
}

.labelOnLeft {
  margin: 0;
}

.labelBold {
  font-weight: bold;
}

.labelNormal {
  font-weight: 500;
}
